const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const èOggi = (data) => {
  const adesso = new Date(); // Ottieni la data e l'ora attuali

  return data.getFullYear() === adesso.getFullYear() &&
  data.getMonth() === adesso.getMonth() &&
  data.getDate() === adesso.getDate()
};

function isDateTimeTodayAndPassed(dataStringa, orario, user) {
  // Converte la stringa in un oggetto Date
  const data = new Date(dataStringa);
  const tolleranza = user && user.ruolo == 'admin' ? (1000 * 60 * 10) : 0
  // Aggiunge l'orario specificato
  const [ore, minuti] = orario.split(":").map(Number); // Divide l'orario in ore e minuti
  data.setHours(ore, minuti, 0, 0); // Imposta ore e minuti sulla data

  const adesso = new Date(); // Ottieni la data e l'ora attuali

  // Funzione per verificare se la data è oggi
  function èOggi(data) {
    const oggi = new Date();
    return data.getDate() === oggi.getDate() && 
           data.getMonth() === oggi.getMonth() &&
           data.getFullYear() === oggi.getFullYear();
  }
  
  return èOggi(data) && (tolleranza + adesso.getTime() - data.getTime() > 0) && (adesso.getTime() - data.getTime() < (120 * 60 * 1000));
}

function isDateTimeInFutureOrNow(dataStringa, orario) {
  // Converte la stringa in un oggetto Date
  const data = new Date(dataStringa);
  
  // Aggiunge l'orario specificato
  const [ore, minuti] = orario.split(":").map(Number);
  data.setHours(ore, minuti, 0, 0);

  const adesso = new Date(); // Data e ora attuali

  // Confronto: ritorna true se la data è nel futuro o è adesso
  return data.getTime() >= adesso.getTime();
}


  function meseInItaliano(data) {
    const mesi = [
      "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
      "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
    ];
    return mesi[data.getMonth()];
  }

  function extractRoomKey(url) {
    if (!url) return "";
    try {
        const urlObj = new URL(url);
        const params = new URLSearchParams(urlObj.search);
        const roomKey = params.get('roomKey');
        return roomKey ? roomKey : "";
    } catch (e) {
        return "";
    }
}

export { formatDate, isDateTimeTodayAndPassed, meseInItaliano, èOggi, extractRoomKey, isDateTimeInFutureOrNow };
